<!-- src/views/BusinessServiceView.vue -->
<template>
    <div class="business-service-page">
      <!-- Hero Section -->
      <div class="hero-section bg-primary text-white py-5">
        <div class="container">
          <h1 class="display-4">
            <i class="fas fa-handshake me-3"></i>Business Services
          </h1>
          <p class="lead">บริการด้านธุรกิจและการจับคู่ทางการค้า</p>
        </div>
      </div>
  
      <!-- Main Content -->
      <div class="container py-5">
        <div class="row g-4">
          <!-- Business Matching Section -->
          <div class="col-lg-6">
            <div class="service-card">
              <div class="service-header">
                <div class="icon-wrapper bg-primary-light">
                  <i class="fas fa-handshake text-primary"></i>
                </div>
                <h2>Business Matching</h2>
              </div>
              
              <div class="service-items">
                <!-- Trade Logistics -->
                <div class="service-item">
                  <i class="fas fa-truck-moving text-primary"></i>
                  <div>
                    <h4>Trade Logistics</h4>
                    <p class="text-muted">การขนส่งการค้า</p>
                    <router-link to="/business/logistics" class="btn btn-outline-primary btn-sm">
                      รายละเอียดเพิ่มเติม
                      <i class="fas fa-arrow-right ms-2"></i>
                    </router-link>
                  </div>
                </div>
  
                <!-- Transaction and Payment -->
                <div class="service-item">
                  <i class="fas fa-money-check-alt text-primary"></i>
                  <div>
                    <h4>Transaction and Payment</h4>
                    <p class="text-muted">การโอนเงินและการจ่ายเงิน</p>
                    <router-link to="/business/payment" class="btn btn-outline-primary btn-sm">
                      รายละเอียดเพิ่มเติม
                      <i class="fas fa-arrow-right ms-2"></i>
                    </router-link>
                  </div>
                </div>
  
                <!-- Guarantee and Authorization -->
                <div class="service-item">
                  <i class="fas fa-certificate text-primary"></i>
                  <div>
                    <h4>Guarantee and Authorization</h4>
                    <p class="text-muted">การรับรองและการอนุญาตสินค้า</p>
                    <router-link to="/business/guarantee" class="btn btn-outline-primary btn-sm">
                      รายละเอียดเพิ่มเติม
                      <i class="fas fa-arrow-right ms-2"></i>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 2CTIC Section -->
          <div class="col-lg-6">
            <div class="service-card">
              <div class="service-header">
                <div class="icon-wrapper bg-success-light">
                  <i class="fas fa-building text-success"></i>
                </div>
                <h2>2CTIC</h2>
                <p>ศูนย์การค้าและการลงทุน</p>
              </div>
  
              <div class="service-items">
                <!-- Research Information -->
                <div class="service-item">
                  <i class="fas fa-search text-success"></i>
                  <div>
                    <h4>Research Information</h4>
                    <p class="text-muted">ข้อมูลการวิจัยที่ผ่านมา</p>
                    <router-link to="/2ctic/research" class="btn btn-outline-success btn-sm">
                      รายละเอียดเพิ่มเติม
                      <i class="fas fa-arrow-right ms-2"></i>
                    </router-link>
                  </div>
                </div>
  
                <!-- Business Trip Package -->
                <div class="service-item">
                  <i class="fas fa-plane text-success"></i>
                  <div>
                    <h4>Package for Business Matching</h4>
                    <p class="text-muted">แพคเก็จสําหรับการจับคู่ธุรกิจและการดูงาน</p>
                    <router-link to="/2ctic/business-trip" class="btn btn-outline-success btn-sm">
                      รายละเอียดเพิ่มเติม
                      <i class="fas fa-arrow-right ms-2"></i>
                    </router-link>
                  </div>
                </div>
  
                <!-- CSR Program -->
                <div class="service-item">
                  <i class="fas fa-heart text-success"></i>
                  <div>
                    <h4>CSR Program</h4>
                    <p class="text-muted">โปรแกรมสําหรับกิจกรรมเพื่อสังคม</p>
                    <router-link to="/2ctic/csr" class="btn btn-outline-success btn-sm">
                      รายละเอียดเพิ่มเติม
                      <i class="fas fa-arrow-right ms-2"></i>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <style scoped>
  .hero-section {
    background: linear-gradient(45deg, #0B8AC6, #06618b);
  }
  
  .service-card {
    background: white;
    border-radius: 16px;
    padding: 2rem;
    height: 100%;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  }
  
  .service-header {
    text-align: center;
    margin-bottom: 2rem;
  }
  
  .icon-wrapper {
    width: 80px;
    height: 80px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1rem;
  }
  
  .icon-wrapper i {
    font-size: 32px;
  }
  
  .bg-primary-light { background: rgba(11,138,198,0.1); }
  .bg-success-light { background: rgba(40,175,96,0.1); }
  
  .service-items {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
  
  .service-item {
    display: flex;
    gap: 1.5rem;
    padding: 1.5rem;
    border-radius: 12px;
    transition: all 0.2s;
  }
  
  .service-item:hover {
    background: #f8f9fa;
    transform: translateX(10px);
  }
  
  .service-item i {
    font-size: 24px;
    margin-top: 0.5rem;
  }
  
  .service-item h4 {
    margin: 0 0 0.5rem;
    font-size: 1.1rem;
  }
  
  .service-item p {
    margin: 0 0 1rem;
    font-size: 0.9rem;
  }
  
  @media (max-width: 991.98px) {
    .service-card {
      margin-bottom: 2rem;
    }
  }
  </style>
  
  <script>
  export default {
    name: 'BusinessServiceView',
    components: {
      // Add any child components here
    }
  }
  </script>